// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__20NEX","modalFooterButton":"ModalNotes_modalFooterButton__aOBxi"};